module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showSchankverlustData = !_vm.showSchankverlustData
            }
          }
        }, on), [_vm._v("%")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Schankverlusttabelle anzeigen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showNurBbrBbr = !_vm.showNurBbrBbr
            }
          }
        }, on), [(_vm.showNurBbrBbr) ? _c('v-icon', [_vm._v("group")]) : _c('v-icon', [_vm._v("groups")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Filter: Nur BbrBbr")])]), _vm._v(" "), (_vm.currentBbr === 'PBChUyAy7HWowQR4HlP3') ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showDebug = !_vm.showDebug
            }
          }
        }, on), [_c('v-icon', [_vm._v("bug_report")])], 1)]
      }
    }], null, false, 2864840511)
  }, [_vm._v(" "), _c('span', [_vm._v("Debug Dialog anzeigen")])]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-tabs', {
    attrs: {
      "centered": "",
      "center-active": ""
    },
    model: {
      value: (_vm.jahrSelect),
      callback: function($$v) {
        _vm.jahrSelect = $$v
      },
      expression: "jahrSelect"
    }
  }, _vm._l((_vm.jahre), function(jahr, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._v("\n            " + _vm._s(jahr) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addMonat(false)
            }
          }
        }, on), [_c('v-icon', [_vm._v("refresh")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Monat berechnen")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.monatSelect),
      callback: function($$v) {
        _vm.monatSelect = $$v
      },
      expression: "monatSelect"
    }
  }, [_vm._l((_vm.monate), function(monat, index) {
    return _c('v-tab', {
      key: index,
      attrs: {
        "disabled": _vm.daten.find(function (datum) { return datum === _vm.jahre[_vm.jahrSelect] + '-' + monat + '-01'; }) === undefined
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + monat, "MMM")) + "\n      ")])
  }), _vm._v(" "), _c('v-tab', [_vm._v(" Jahr ")])], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.statistik !== null) ? _c('v-row', {
    staticClass: "mt-4 ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.showSchankverlustData) ? _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "first",
      "cols": "12",
      "xs": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSchankverlustData = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Zeitraum")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Oettingerkisten")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Schankverlust")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Striche Theorie")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Striche Praxis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Couleurstriche")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber lighten-2"
  }, [_vm._v("Kosten Oettinger"), _c('br'), _vm._v("und Couleurbier")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber lighten-2"
  }, [_vm._v("Fehlbetrag "), _c('br'), _vm._v("Schankverlust")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber lighten-2"
  }, [_vm._v("Fehlbetrag "), _c('br'), _vm._v("Schankverlust (-10%)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center amber"
  }, [_vm._v("Summe")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + _vm.monate[_vm.monatSelect], "MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.oettingerKisten))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.schankverlust) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.gesamtStricheTheorie))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.gesamtStrichePraxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statistik.couleurstricheAnzahl))]), _vm._v(" "), _c('td', {
    staticClass: "amber lighten-2"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")((parseFloat(_vm.statistik.oettingerKistenPreis) + parseFloat(_vm.statistik.couleurstrichePreis)))) + "\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "amber lighten-2"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "amber lighten-2"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")(((_vm.statistik.gesamtStricheTheorie -
      _vm.statistik.gesamtStricheTheorie * 0.1 -
      _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "amber"
  }, [_vm._v("\n                " + _vm._s(_vm._f("money")((parseFloat(_vm.statistik.oettingerKistenPreis) +
    parseFloat(_vm.statistik.couleurstrichePreis) +
    (_vm.statistik.gesamtStricheTheorie - _vm.statistik.gesamtStrichePraxis) *
    _vm.statistik.durchschnittsStrichPreis))) + "\n              ")])])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order-xs": "",
      "cols": "12",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Bester Tag"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.date(_vm.statistik.stricheProTagBest[0], "DD.MM.YYYY"))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.stricheProTagBest[1]) + " Striche"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("BbrBbr an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.stricheProBbrCount)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Couleurstriche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.couleurstricheAnzahl)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Striche (ohne EKP)"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.statistik.stricheBbrAnzahl)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "absolute": "",
      "icon": "",
      "right": "",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": function($event) {
        return _vm.showVermogen()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 overline justify-center"
  }, [_vm._v("Vermögen")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.$sumArray(_vm.statistik.gesamtvermogen))) + "\n        ")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline justify-center"
  }, [_vm._v("Steuerlast an AHV")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.statistik.steuerlast)) + "\n        ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order-xs": "",
      "cols": "12",
      "md": "10"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showArray = 'schankverlust') && _vm.show(_vm.jahresStatistik.schankverlust)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "overline pa-0 justify-space-between"
  }, [_c('v-icon', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v("touch_app")]), _vm._v("\n                  Schankverlust\n                  "), _c('v-icon', [_vm._v("touch_app")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.schankverlust) + "%")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showArray = 'gesamtStriche') && _vm.show(_vm.jahresStatistik.gesamtStriche)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "overline pa-0 justify-space-between"
  }, [_c('v-icon', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v("touch_app")]), _vm._v("\n                  Striche\n                  "), _c('v-icon', [_vm._v("touch_app")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.gesamtStricheTheorie) + " | " + _vm._s(_vm.statistik.gesamtStrichePraxis))])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        (_vm.showArray = 'volumen') && _vm.show(_vm.jahresStatistik.volumen)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "overline pa-0 justify-space-between"
  }, [_c('v-icon', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v("touch_app")]), _vm._v("\n                  Volumen\n                  "), _c('v-icon', [_vm._v("touch_app")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_vm._v(_vm._s(_vm.statistik.volumen) + "L")])], 1)], 1)], 1), _vm._v(" "), (_vm.showArray === 'schankverlust') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "200",
      "type": "bar",
      "options": _vm.options4,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showArray === 'gesamtStriche') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "200",
      "type": "area",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showArray === 'volumen') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "200",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showArray === 'vermogen') ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "calc(100% - 82px)"
    }
  }, [(_vm.statistik.gesamtvermogen) ? _c('v-row', {
    staticClass: "pa-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Kontostand"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.kontostand),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "kontostand", $$v)
      },
      expression: "statistik.gesamtvermogen.kontostand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Getränkestand"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.getrankestand),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "getrankestand", $$v)
      },
      expression: "statistik.gesamtvermogen.getrankestand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Fuxenkasse"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.fuxenkasse),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "fuxenkasse", $$v)
      },
      expression: "statistik.gesamtvermogen.fuxenkasse"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "label": "Sonstiges"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.sonstiges),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "sonstiges", $$v)
      },
      expression: "statistik.gesamtvermogen.sonstiges"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Offene Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_offen),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_offen", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_offen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Offene SEPA-Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_sepa),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_sepa", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_sepa"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Überfällige Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_ueberfaellig),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_ueberfaellig", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_ueberfaellig"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "number": "",
      "label": "Gemahnte Rechnungen"
    },
    model: {
      value: (_vm.statistik.gesamtvermogen.rechnungen_gemahnt),
      callback: function($$v) {
        _vm.$set(_vm.statistik.gesamtvermogen, "rechnungen_gemahnt", $$v)
      },
      expression: "statistik.gesamtvermogen.rechnungen_gemahnt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                Trag hier alle Werte zum Ende des Monats ein.\n                "), _c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveGesamtvermogen()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-2",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-tab', [_vm._v("BbrBbr")]), _vm._v(" "), _c('v-tab', [_vm._v("Status")]), _vm._v(" "), _c('v-tab-item', [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.statistik.stricheProBbrSortiert), function(item, index) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showBbr = true)
        }
      }
    }, [(index === 0) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "amber--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 1) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "deep-orange--text darken-3"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index > 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item[0], _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])
  }), 0)])], 1), _vm._v(" "), _c('v-tab-item', [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.statistik.stricheProStatusSortiert), function(item, index) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showBbr = true)
        }
      }
    }, [(index === 0) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "amber--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 1) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "deep-orange--text darken-3"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index > 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "48",
      "value": (_vm.statistik.verbrauchBierSumme / _vm.statistik.volumen) * 100,
      "color": "primary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Bier")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v(_vm._s(_vm.statistik.verbrauchBierSumme) + " L")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "223px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.verbrauchBier), function(item) {
    return _c('tr', {
      key: item.bezeichnung,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.verbraucht))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "48",
      "value": (_vm.statistik.verbrauchSoftdrinksSumme / _vm.statistik.volumen) * 100,
      "color": "tertiary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Softdrinks")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v(_vm._s(_vm.statistik.verbrauchSoftdrinksSumme) + " L")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "223px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.verbrauchSoftdrinks), function(item) {
    return _c('tr', {
      key: item.bezeichnung,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.verbraucht))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "48",
      "value": (_vm.statistik.verbrauchWeinSchnapsSumme / _vm.statistik.volumen) * 100,
      "color": "amber"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_vm._v("Wein & Schnaps")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v(_vm._s(_vm.statistik.verbrauchWeinSchnapsSumme) + " L")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "223px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik.verbrauchWeinSchnaps), function(item) {
    return _c('tr', {
      key: item.bezeichnung,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.verbraucht))])])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "caption ml-4"
  }, [_vm._v("\n        Zuletzt aktualisiert: " + _vm._s(_vm.$filters.date(_vm.statistik.aktualisiert.seconds * 1000, "DD.MM.YYYY hh:mm")))])])], 1) : _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [(_vm.monatSelect === 12) ? _c('v-col', {
    staticClass: "hidden-xl-only",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "5",
      "order-md": "1",
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("BbrBbr an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste.length)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Tage an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.tageAnDerTheke)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStriche.summe)), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Bester Tag"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.date(_vm.jahrStatistik.besterTag.datum, "DD.MM.YYYY"))), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Bester Tag"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.besterTag.anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "order": "4",
      "order-md": "2",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mx-1 px-1 mx-sm-12 px-sm-12",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-4 px-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-2",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "grey--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-3 overline"
  }, [_c('v-spacer'), _vm._v("2. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _c('v-spacer', [_vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[1].bbr, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[1].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "amber lighten-4",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "amber--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-6 overline"
  }, [_c('v-spacer'), _vm._v("1. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _c('v-spacer', [_vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[0].bbr, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[0].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-7",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "deep-orange lighten-5",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "deep-orange--text darken-3",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("3. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _c('v-spacer', [_vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[2].bbr, _vm.bbrbbr)))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[2].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mt-6",
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "152px"
    }
  }, [_c('tbody', _vm._l((_vm.jahrStatistik.bestenliste), function(item, index) {
    return (index > 2) ? _c('tr', {
      key: item.bbr
    }, [_c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(item.anzahl))])]) : _vm._e()
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "6",
      "order-md": "3",
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Schankverlust"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.schankverlust.gesamt) + " %"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.schankverlust.preis))), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Couleurstriche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.couleurstriche) + " Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.oettingerKisten.summe) + " Ötti-Kisten"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")((_vm.jahrStatistik.oettingerKisten.preis + _vm.jahrStatistik.couleurstrichePreis)))), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Umsatz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.summe))), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "2",
      "order-md": "4",
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "250",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchBierSorte
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": _vm.jahrStatistik.verbrauchBier.donut.series[index],
            "color": _vm.jahrStatistik.verbrauchBier.donut.series[index] > 50 ?
              'primary' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 25 ?
              'primary lighten-1' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 10 ?
              'primary lighten-2' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 5 ?
              'primary lighten-3' :
              'primary lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.Id))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(_vm.jahrStatistik.verbrauchBier.donut.series[index]) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 714915272)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "1",
      "order-md": "5",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 mt-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-5 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "primary"
    }
  }, [_vm._v("Bier")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[0].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "tertiary"
    }
  }, [_vm._v("Softdrinks")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[1].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "amber"
    }
  }, [_vm._v("Wein & Schnaps")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[2].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "291px",
      "type": "donut",
      "options": _vm.jahrStatistik.volumen.chartOptions,
      "series": _vm.jahrStatistik.volumen.donut.series
    }
  })], 1)], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "height": "200",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.jahrStatistik.volumen
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "order": "3",
      "order-md": "6",
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "250",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchSoftdrinks
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100,
            "color": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 25 ?
              'red' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 20 ?
              'red lighten-1' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 10 ?
              'red lighten-2' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 5 ?
              'red lighten-3' :
              'red lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "text-truncate",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(((item.liter / _vm.jahrStatistik.volumen[1].summe) * 100).toFixed(1)) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 1948615279)
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.monatSelect === 12) ? _c('v-col', {
    staticClass: "hidden-lg-and-down",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("an der Theke"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste.length) + " BbrBbr"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.tageAnDerTheke) + " Tage"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 pt-2 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.date(_vm.jahrStatistik.besterTag.datum, "DD.MM.YYYY"))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.besterTag.anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Striche"), _c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStriche.summe) + " (" + _vm._s(((_vm.jahrStatistik.gesamtStriche.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) * 100).toFixed(1)) + "\n                  %)")], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Striche EKP"), _c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) + " (" + _vm._s((
          ((_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) /
            _vm.jahrStatistik.gesamtStricheTheorie.summe) *
          100
        ).toFixed(1)) + "\n                  %)")], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Schankverlust"), _c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe) + " (" + _vm._s((
          100 -
          (_vm.jahrStatistik.gesamtStrichePraxis.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) * 100
        ).toFixed(1)) + "\n                  %)")], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.gesamtStricheTheorie.summe))], 1)], 1)]
      }
    }], null, false, 3999797632)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Anzahl Striche an Gesamtvolumen"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, _vm._l((_vm.jahrStatistik.gesamtStriche.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "17",
        "value": ((item / _vm.jahrStatistik.gesamtStricheTheorie.data[index]) * 100).toFixed(1),
        "color": "tertiary"
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "caption text-truncate",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(new Date(_vm.jahre[_vm.jahrSelect], index), "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "caption text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v("\n                      " + _vm._s(((item / _vm.jahrStatistik.gesamtStricheTheorie.data[index]) * 100).toFixed(1)) + " %\n                    ")])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-progress-linear', {
    staticClass: "my-1",
    attrs: {
      "rounded": "",
      "height": "28",
      "value": ((_vm.jahrStatistik.gesamtStriche.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) * 100).toFixed(1),
      "color": "tertiary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "title text-right",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                      " + _vm._s((
    (_vm.jahrStatistik.gesamtStriche.summe / _vm.jahrStatistik.gesamtStricheTheorie.summe) *
    100
  ).toFixed(1)) + "\n                      %\n                    ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Schankverlust"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.schankverlust.gesamt) + " %"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 subtitle-2"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.schankverlust.preis))), _c('v-spacer')], 1)], 1)]
      }
    }], null, false, 3900815369)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Schankverlust"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, _vm._l((_vm.jahrStatistik.schankverlust.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "17",
        "value": (item / 50) * 100,
        "color": "tertiary"
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "caption text-truncate",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(new Date(_vm.jahre[_vm.jahrSelect], index), "MM.YYYY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "caption text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(item) + " %")])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-progress-linear', {
    staticClass: "my-1",
    attrs: {
      "rounded": "",
      "height": "28",
      "value": (_vm.jahrStatistik.schankverlust.gesamt / 50) * 100,
      "color": "tertiary"
    }
  }, [_c('v-row', {
    staticClass: "mx-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "caption text-truncate",
    attrs: {
      "cols": "6"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "title text-right",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v(_vm._s(_vm.jahrStatistik.schankverlust.gesamt) + " %")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Couleurstriche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.couleurstriche) + " Striche"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.oettingerKisten.summe) + " Ötti-Kisten"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")((_vm.jahrStatistik.oettingerKisten.preis + _vm.jahrStatistik.couleurstrichePreis)))), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Einkauf"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Bier Schneider"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.bierschneider)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Metro"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.metro)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Oettinger"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.oettinger)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.summe)))], 1)], 1)]
      }
    }], null, false, 817975205)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Einkauf nach Lieferant"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Bier Schneider"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.bierschneider)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Metro"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.metro)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Oettinger"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.oettinger)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Rewe"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.rewe)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Vendel"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.vendel)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2"
  }, [_vm._v("Vinos"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.vinos)))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.einkauf.summe)))], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "color": "orange",
      "min-width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-card', _vm._g({
          staticClass: "mb-1",
          attrs: {
            "outlined": "",
            "height": "100%"
          }
        }, on), [_c('v-card-title', {
          staticClass: "pa-0 overline"
        }, [_c('v-spacer'), _vm._v("Umsatz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Striche"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.striche)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("EKP"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.ekp)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4 subtitle-2"
        }, [_vm._v("Pauschal"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.pauschal)))], 1), _vm._v(" "), _c('v-card-title', {
          staticClass: "pa-0 px-4"
        }, [_c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.summe)))], 1)], 1)]
      }
    }], null, false, 1397910170)
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("Davon gingen Rechnungen an"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Bierspenden"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.bierkasse)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Aktivenkasse"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.aktivenkasse)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Fuxenkasse"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.ahv)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("AHV"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.hbv)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("HBV"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.fuxia)))], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4 subtitle-2"
  }, [_vm._v("Couleur"), _c('v-spacer'), _vm._v(_vm._s(_vm._f("money")(_vm.jahrStatistik.umsatz.couleur)))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 px-4"
  }, [_c('v-spacer'), _vm._v("\n                " + _vm._s(_vm._f("money")((_vm.jahrStatistik.umsatz.bierkasse +
    _vm.jahrStatistik.umsatz.aktivenkasse +
    _vm.jahrStatistik.umsatz.ahv +
    _vm.jahrStatistik.umsatz.hbv +
    _vm.jahrStatistik.umsatz.fuxia +
    _vm.jahrStatistik.umsatz.couleur))) + "\n              ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "228",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchBierSorte
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": _vm.jahrStatistik.verbrauchBier.donut.series[index],
            "color": _vm.jahrStatistik.verbrauchBier.donut.series[index] > 50 ?
              'primary' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 25 ?
              'primary lighten-1' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 10 ?
              'primary lighten-2' :
              _vm.jahrStatistik.verbrauchBier.donut.series[index] > 5 ?
              'primary lighten-3' :
              'primary lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.Id))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(_vm.jahrStatistik.verbrauchBier.donut.series[index]) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "4"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 714915272)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 mt-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-5 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "primary"
    }
  }, [_vm._v("Bier")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[0].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "tertiary"
    }
  }, [_vm._v("Softdrinks")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[1].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-badge', {
    attrs: {
      "dot": "",
      "inline": "",
      "left": "",
      "color": "amber"
    }
  }, [_vm._v("Wein & Schnaps")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.volumen[2].summe)), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 caption"
  }, [_c('v-spacer'), _vm._v("Liter"), _c('v-spacer')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "267px",
      "type": "donut",
      "options": _vm.jahrStatistik.volumen.chartOptions,
      "series": _vm.jahrStatistik.volumen.donut.series
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('apexchart', {
    attrs: {
      "height": "231",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.jahrStatistik.volumen
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "228",
      "bench": "2",
      "item-height": "19",
      "items": _vm.jahrStatistik.stricheProTag
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "17",
            "value": (item.summe / _vm.jahrStatistik.stricheProTagMax) * 100,
            "color": "primary lighten-2"
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "caption text-truncate",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(_vm.$filters.date(new Date(_vm.jahre[_vm.jahrSelect], index), "MM.YYYY")))]), _vm._v(" "), _c('v-col', {
          staticClass: "caption text-right",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(item.summe) + " Striche")])], 1)], 1)]
      }
    }], null, false, 3773264116)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-1 pa-2 pt-1",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-virtual-scroll', {
    staticClass: "mt-1",
    attrs: {
      "height": "228",
      "bench": "2",
      "item-height": "36",
      "items": _vm.jahrStatistik.verbrauchSoftdrinks
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-progress-linear', {
          attrs: {
            "rounded": "",
            "height": "32",
            "value": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100,
            "color": (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 25 ?
              'red' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 20 ?
              'red lighten-1' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 10 ?
              'red lighten-2' :
              (item.liter / _vm.jahrStatistik.volumen[1].summe) * 100 > 5 ?
              'red lighten-3' :
              'red lighten-4'
          }
        }, [_c('v-row', {
          staticClass: "mx-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "text-truncate",
          attrs: {
            "cols": "6"
          }
        }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "4"
          }
        }, [_c('strong', [_vm._v(_vm._s(((item.liter / _vm.jahrStatistik.volumen[1].summe) * 100).toFixed(1)) + "%")])]), _vm._v(" "), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(item.liter) + " l")])], 1)], 1)]
      }
    }], null, false, 1948615279)
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Preise")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Strich")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Schankverlust")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Kosten pro Strich")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.kostenStriche)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.kostenEKP)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.kostenSchankverlust)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Einnahmen pro Strich")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.einnahmenStriche)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.einnahmenEKP)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.einnahmenSchankverlust)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Gewinn pro Strich")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.gewinnStriche)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.gewinnEKP)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.preiskalkulation.gewinnSchankverlust)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Anzahl Striche")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.jahrStatistik.gesamtStriche.summe))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Gewinn")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnStriche * _vm.jahrStatistik.gesamtStriche.summe))) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnEKP *
    (_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe)))) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnSchankverlust *
    (_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe)))) + "\n                  ")])]), _vm._v(" "), _c('tr', {
    staticClass: "font-weight-bold mt-4"
  }, [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("money")((_vm.preiskalkulation.gewinnStriche * _vm.jahrStatistik.gesamtStriche.summe +
    _vm.preiskalkulation.gewinnEKP *
    (_vm.jahrStatistik.gesamtStrichePraxis.summe - _vm.jahrStatistik.gesamtStriche.summe) +
    _vm.preiskalkulation.gewinnSchankverlust *
    (_vm.jahrStatistik.gesamtStricheTheorie.summe - _vm.jahrStatistik.gesamtStrichePraxis.summe)))) + "\n                  ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Bier")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Striche")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik.verbrauchBier), function(item) {
    return _c('tr', {
      key: item.bezeichnung
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.preis)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.verkauf1)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.getrank.striche))]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Softdrinks")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Striche")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik.verbrauchSoftdrinks), function(item) {
    return _c('tr', {
      key: item.bezeichnung
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.preis)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.verkauf1)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.getrank.striche))]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Wein & Schnaps")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "300px",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EKP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Verbraucht")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("VK-Striche")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik.verbrauchWeinSchnaps), function(item) {
    return _c('tr', {
      key: item.bezeichnung
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.ekp))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.preis)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.getrank.verkauf1)))]) : _vm._e(), _vm._v(" "), (item.getrank) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.getrank.striche))]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "justify-center py-1"
  }, [_vm._v("Vermögen")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-1"
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mb-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "px-1 mx-4 mt-4",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-4 px-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-2",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "grey--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-3 overline"
  }, [_c('v-spacer'), _vm._v("2. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[1].bbr, _vm.bbrbbr))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[1].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "amber lighten-4",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "amber--text lighten-1",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pt-6 overline"
  }, [_c('v-spacer'), _vm._v("1. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[0].bbr, _vm.bbrbbr))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[0].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 mt-7",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "deep-orange lighten-5",
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pt-2 overline"
  }, [_c('v-spacer'), _c('v-icon', {
    staticClass: "deep-orange--text darken-3",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("emoji_events")]), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 overline"
  }, [_c('v-spacer'), _vm._v("3. Platz"), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 subtitle-2 text-truncate"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.$filters.user(_vm.jahrStatistik.bestenliste[2].bbr, _vm.bbrbbr))), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0 pb-2 caption"
  }, [_c('v-spacer'), _vm._v(_vm._s(_vm.jahrStatistik.bestenliste[2].anzahl) + " Striche"), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mt-6",
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "152px"
    }
  }, [_c('tbody', _vm._l((_vm.jahrStatistik.bestenliste), function(item, index) {
    return (index > 2) ? _c('tr', {
      key: item.bbr
    }, [_c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbr, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_vm._v(_vm._s(item.anzahl))])]) : _vm._e()
  }), 0)])], 1)], 1)], 1)], 1) : _c('v-col', {
    attrs: {
      "cols": "4",
      "offset": "4"
    }
  }, [_vm._l((_vm.errorMessage), function(item, index) {
    return _c('v-alert', {
      key: index,
      attrs: {
        "type": "info"
      }
    }, [_vm._v("\n        " + _vm._s(item[1]) + "\n      ")])
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "warning",
      "outlined": "",
      "border": "left"
    }
  }, [_vm._v("\n        Die Statistik kann erst erstellt werden, wenn die Getränkezählung von Monatsanfang und Monatsende vorliegen.\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.zahlungExist
    },
    on: {
      "click": function($event) {
        return _vm.addMonat(true)
      }
    }
  }, [_vm._v("Monat berechnen")])], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showDebug),
      callback: function($$v) {
        _vm.showDebug = $$v
      },
      expression: "showDebug"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', {
    staticClass: "green"
  }, [_vm._v("\n        Debug Fenster\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDebug = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "100%",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Data")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statistik), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (Array.isArray(item)) ? _c('td', [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((item), function(item2, index) {
      return _c('v-list-item', {
        key: index
      }, [_c('v-list-item-icon', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-list-item-content', [_vm._v(_vm._s(item2))])], 1)
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item))])])
  }), 0)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "100%",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Data")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.jahrStatistik), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (Array.isArray(item)) ? _c('td', [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((item), function(item2, index) {
      return _c('v-list-item', {
        key: index
      }, [_c('v-list-item-icon', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-list-item-content', [_vm._v(_vm._s(item2))])], 1)
    }), 1)], 1) : _c('td', [_vm._v(_vm._s(item))])])
  }), 0)])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa695846"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/bierwartSchankverlust.vue
// module id = 805
// module chunks = 15